<div class="modal-header navbar-alertia">
    <button type="button" title="{{ 'general.close_window' | translate }}" class="close" (click)="activeModal.close(false)">&times;</button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            <img [src]="link" />
        </div>
    </div>
</div>
